(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hp-curved-title"] && !Shopify.designMode) return;
  try {
    if (!window.hpCurveTravel) {
    // Moves a curved title along its path as the page scrolls. The host's data-title-travel (0-100) sets full-path travel; 0 falls back to data-heading-movement.
    window.hpCurveTravel = (host, heading, { signal, sourceOffset, onMove }) => {
      const opts = { signal };
      let frame = 0;
      let nearViewport = false;
      let metrics = null;
      const position = () => {
        frame = 0;
        if (!nearViewport || document.hidden || signal.aborted || !heading.getClientRects().length) return;
        if ((window.hpMotion?.paused && !window.hpMotion?.reduced) || host.querySelector('.hp-editor-block-selected')) return;
        if (!metrics) {
          const text = heading.querySelector('text');
          const textPath = text?.querySelector('textPath');
          if (!textPath || !text.getNumberOfChars()) return;
          const mobile = matchMedia('(max-width: 768px)').matches;
          const configuredMovement = Number(host.dataset.headingMovement);
          const movement = Number.isFinite(configuredMovement) ? Math.max(1, Math.min(100, configuredMovement)) : 25;
          const fullTravel = Math.max(0, Math.min(100, Number(host.dataset.titleTravel) || 0));
          const source = sourceOffset(mobile);
          const path = heading.querySelector('path');
          const pathLength = path?.getTotalLength() || 1;
          const textLength = textPath.getComputedTextLength();
          const charCount = textPath.getNumberOfChars();
          // Glyph midpoints must stay on the path; cache advances until fonts or layout change.
          const firstAdvance = charCount ? textPath.getSubStringLength(0, 1) : 0;
          const lastAdvance = charCount ? textPath.getSubStringLength(charCount - 1, 1) : 0;
          const firstEdge = Math.max(0, (textLength - firstAdvance) / pathLength * 50 + 0.02);
          const lastEdge = Math.max(0, (textLength - lastAdvance) / pathLength * 50 + 0.02);
          let endPercent = 100;
          const pathMatrix = fullTravel && mobile && path?.getScreenCTM();
          if (pathMatrix) {
            const limit = innerWidth - lastAdvance * Math.hypot(pathMatrix.a, pathMatrix.b) / 2;
            let low = 0, high = pathLength;
            // Both curve paths run monotonically left-to-right, including on mobile.
            for (let i = 0; i < 24; i++) {
              const mid = (low + high) / 2;
              const point = path.getPointAtLength(mid);
              const screen = new DOMPoint(point.x, point.y).matrixTransform(pathMatrix);
              if (screen.x <= limit) low = mid;
              else high = mid;
            }
            endPercent = low / pathLength * 100;
          }
          const maxAnchor = endPercent - lastEdge;
          const usable = Math.max(0, maxAnchor - firstEdge);
          const travel = fullTravel ? usable * fullTravel / 100 : Math.min(movement * 0.36, usable);
          const start = fullTravel >= 100 ? firstEdge : Math.max(firstEdge, Math.min(maxAnchor - travel, source - travel / 2));
          const headerH = fullTravel ? parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 0 : 0;
          metrics = { text, textPath, mobile, source, travel, start, headerH, tracked: fullTravel ? heading : host, last: text.getNumberOfChars() - 1 };
        }
        const { textPath, source, travel, start } = metrics;
        const bounds = metrics.tracked.getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (innerHeight - bounds.top) / (innerHeight - metrics.headerH + bounds.height)));
        const offset = window.hpMotion?.reduced ? source : start + progress * travel;
        textPath.setAttribute('startOffset', offset + '%');
        onMove?.(metrics);
      };
      const request = () => {
        if (nearViewport && !document.hidden && !frame && !signal.aborted) frame = requestAnimationFrame(position);
      };
      const invalidate = () => { metrics = null; request(); };
      const settingsObserver = new MutationObserver(invalidate);
      settingsObserver.observe(host, { attributes: true, attributeFilter: ['data-heading-movement', 'data-title-travel'] });
      settingsObserver.observe(heading, { childList: true, subtree: true, characterData: true });
      const sizeObserver = new ResizeObserver(invalidate);
      sizeObserver.observe(heading);
      const visibility = new IntersectionObserver((entries) => {
        nearViewport = entries.some((entry) => entry.isIntersecting);
        if (nearViewport) request();
        else { cancelAnimationFrame(frame); frame = 0; }
      }, { rootMargin: '200px 0px' });
      visibility.observe(host);
      addEventListener('scroll', request, { passive: true, signal });
      addEventListener('resize', invalidate, opts);
      document.addEventListener('hp:motion:change', request, opts);
      host.addEventListener('hp:editor:block-deselect', request, opts);
      document.addEventListener('visibilitychange', request, opts);
      document.fonts.addEventListener('loadingdone', invalidate, opts);
      document.fonts.ready.then(() => { if (host.isConnected && !signal.aborted) invalidate(); });
      signal.addEventListener('abort', () => {
        sizeObserver.disconnect();
        settingsObserver.disconnect();
        visibility.disconnect();
        cancelAnimationFrame(frame);
      });
    };
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-editor-block-events"] && !Shopify.designMode) return;
  try {
    if (window.Shopify?.designMode) {
    document.addEventListener('shopify:block:select', (event) => {
      event.target.classList?.add('hp-editor-block-selected');
      event.target.dispatchEvent(new CustomEvent('hp:editor:block-select', { detail: event.detail, bubbles: true }));
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      event.target.classList?.remove('hp-editor-block-selected');
      event.target.dispatchEvent(new CustomEvent('hp:editor:block-deselect', { detail: event.detail, bubbles: true }));
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-motion-controller"] && !Shopify.designMode) return;
  try {
    if (!window.hpMotion) {
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    let userPaused = false;
    const publish = () => {
      document.documentElement.toggleAttribute('data-hp-motion-paused', userPaused || reduced.matches || document.hidden);
      document.dispatchEvent(new CustomEvent('hp:motion:change'));
    };
    window.hpMotion = Object.freeze({
      get paused() { return userPaused || reduced.matches; },
      get reduced() { return reduced.matches; },
      get userPaused() { return userPaused; },
      setPaused(value) { userPaused = Boolean(value); publish(); },
      type(el, { delay = 0 } = {}) {
        if (!el || el.dataset.hpTyped !== undefined) return;
        el.dataset.hpTyped = '';
        if (reduced.matches || userPaused || window.Shopify?.designMode) return;
        const text = [...el.textContent];
        // Untyped glyphs become no-break spaces so every line wraps exactly as the finished text.
        const mask = (i) => text.slice(0, i).join('') + text.slice(i).join('').replace(/[^\s-]/g, '\u00a0');
        let i = 0, timer;
        const done = () => {
          clearTimeout(timer);
          el.removeAttribute('data-hp-typing');
          el.removeAttribute('data-hp-typed-text');
          document.removeEventListener('hp:motion:change', onChange);
        };
        const onChange = () => { if (userPaused || reduced.matches) done(); };
        const tick = () => {
          el.setAttribute('data-hp-typed-text', mask(++i));
          if (i >= text.length) return done();
          const c = text[i - 1];
          timer = setTimeout(tick, /[.!?]/.test(c) ? 280 : /[,;:]/.test(c) ? 140 : 35);
        };
        el.setAttribute('data-hp-typed-text', mask(0));
        el.setAttribute('data-hp-typing', '');
        document.addEventListener('hp:motion:change', onChange);
        timer = setTimeout(tick, delay);
      }
    });
    reduced.addEventListener('change', publish);
    document.addEventListener('visibilitychange', publish);
    publish();
  }

  if (!customElements.get('hp-motion-scene')) {
    customElements.define('hp-motion-scene', class extends HTMLElement {
      connectedCallback() {
        this.io?.disconnect();
        this.mediaIo?.disconnect();
        const images = this.querySelectorAll('.hp-animated-image__animated, .hp-animated-image__still');
        const animated = this.querySelector('.hp-animated-image__animated');
        if (animated) {
          this.setAttribute('data-hp-animated-image-pending', '');
          const mediaIo = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            images.forEach((image) => { image.loading = 'eager'; });
            mediaIo.disconnect();
            animated.decode().then(() => {
              if (this.mediaIo === mediaIo) this.removeAttribute('data-hp-animated-image-pending');
            }, () => {});
          }, { rootMargin: '2000px 0px' });
          this.mediaIo = mediaIo;
          this.mediaIo.observe(this);
        }
        this.io = new IntersectionObserver((entries) => {
          this.toggleAttribute('data-hp-motion-out-of-view', !entries.some((entry) => entry.isIntersecting));
        });
        this.io.observe(this);
      }
      disconnectedCallback() {
        this.io?.disconnect();
        this.mediaIo?.disconnect();
        this.mediaIo = null;
      }
    });
  }
  (() => {
    const html = document.documentElement;
    if (html.hasAttribute('data-hp-reveal-init') || !('IntersectionObserver' in window)) return;
    html.setAttribute('data-hp-reveal-init', '');
    const selector = '[data-hp-reveal]:not([data-hp-reveal-off] *)';
    const armed = 'is-hp-armed', done = 'is-revealed';
    const seen = new WeakSet();
    const observed = new Map();
    const disabled = () => window.Shopify?.designMode || window.hpMotion?.paused ||
      matchMedia('(prefers-reduced-motion: reduce)').matches;
    const rendered = (el) => el.getClientRects().length > 0;
    const onScreen = (el) => {
      const rect = el.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
    };
    const triggerOf = (el) => el.closest('[data-hp-reveal-root]') || el;
    const targets = (root) => root.hasAttribute('data-hp-reveal-root')
      ? [...root.querySelectorAll(selector)].filter((el) => triggerOf(el) === root) : [root];
    const show = (root, list, immediate = false) => {
      if (root.hasAttribute('data-hp-reveal-root')) {
        targets(root).filter(rendered).forEach((el, i) => el.style.setProperty('--i', i));
      }
      list.forEach((el) => {
        if (immediate) el.classList.remove(armed);
        el.classList.add(done);
        if (el.hasAttribute('data-hp-type')) window.hpMotion?.type?.(el, { delay: immediate ? 0 : 500 });
      });
    };
    const unobserve = (root) => { observed.get(root)?.unobserve(root); observed.delete(root); };
    const rearm = (root) => targets(root).forEach((el) => {
      el.classList.remove(done);
      el.classList.add(armed);
    });
    // data-hp-reveal-start="65": hidden from first paint by CSS; plays at once if on screen at load, else when the top crosses 65%.
    const holding = (root) => {
      const runs = targets(root).flatMap((el) => el.getAnimations({ subtree: true }))
        .filter((a) => a.animationName === 'hp-reveal-line');
      if (!runs.length) return targets(root).some((el) => el.classList.contains(armed) && !el.classList.contains(done)) ? 'waiting' : null;
      return runs.some((a) => a.currentTime > a.effect.getComputedTiming().delay) ? 'playing' : 'waiting';
    };
    const ios = new Map();
    const observe = (root, now = false) => {
      if (observed.has(root)) return;
      const start = now ? '100' : root.getAttribute('data-hp-reveal-start');
      if (!ios.has(start)) {
        ios.set(start, new IntersectionObserver(reveal, start
          ? { rootMargin: `0px 0px ${start - 100}% 0px` }
          : { threshold: 0.15, rootMargin: '0px 0px -5% 0px' }));
      }
      observed.set(root, ios.get(start));
      ios.get(start).observe(root);
    };
    const reveal = (entries) => {
      entries.forEach(({ target, isIntersecting }) => {
        if (!target.isConnected) { unobserve(target); return; }
        const replay = target.hasAttribute('data-hp-reveal-replay');
        if (disabled()) {
          show(target, targets(target), true);
        } else if (isIntersecting) {
          show(target, targets(target).filter((el) => !el.classList.contains(done)));
          if (!replay) unobserve(target);
        } else if (replay && !rendered(target)) {
          rearm(target);
        }
      });
    };
    const scan = (scope) => {
      if (!scope.querySelectorAll) return;
      const found = [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
      new Set(found.map(triggerOf)).forEach((root) => {
        const hold = root.hasAttribute('data-hp-reveal-start') ? holding(root) : null;
        const fresh = targets(root).filter((el) => !seen.has(el));
        fresh.forEach((el) => {
          seen.add(el);
          // Vue may copy classes from an old node; identity, not markup, owns state.
          el.classList.remove(armed, done);
        });
        if (hold === 'playing' && !disabled()) return;
        if (disabled() || (!hold && onScreen(root))) show(root, fresh, true);
        else fresh.forEach((el) => el.classList.add(armed));
        if (((hold || !onScreen(root)) && fresh.length) || root.hasAttribute('data-hp-reveal-replay')) observe(root, Boolean(hold) && onScreen(root));
      });
    };
    const pending = new Set();
    let frame = 0;
    const mo = new MutationObserver((records) => {
      records.forEach((record) => {
        record.addedNodes.forEach((node) => { if (node.nodeType === 1) pending.add(node); });
        // A hidden year can already be outside the viewport, so IO alone misses it.
        if (record.type === 'attributes' && record.target.hasAttribute('data-hp-reveal-replay')) {
          if (disabled()) show(record.target, targets(record.target), true);
          else if (!rendered(record.target)) rearm(record.target);
          pending.add(record.target);
        }
      });
      if (!frame) frame = requestAnimationFrame(() => {
        frame = 0;
        observed.forEach((io, root) => { if (!root.isConnected) unobserve(root); });
        pending.forEach((node) => { if (node.isConnected) scan(node); });
        pending.clear();
      });
    });
    const start = () => {
      if (!document.querySelector(selector)) return;
      scan(document);
      mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] });
      document.addEventListener('hp:motion:change', () => {
        if (disabled()) {
          document.querySelectorAll(selector).forEach((el) => show(triggerOf(el), [el], true));
        }
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-ticker-band"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hp-ticker')) {
    customElements.define('hp-ticker', class extends HTMLElement {
      connectedCallback() {
        this.ro?.disconnect();
        this.io?.disconnect();
        this.ac?.abort();
        this.ac = new AbortController();
        if (this.classList.contains('hp-ticker--static')) return;
        const viewport = this.querySelector('.hp-ticker__viewport');
        const track = this.querySelector('.hp-ticker__track');
        const source = track?.firstElementChild;
        if (!viewport || !source) return;
        const sync = () => {
          const width = source.getBoundingClientRect().width;
          if (!width || !viewport.clientWidth) return;
          const copies = Math.max(2, Math.ceil(viewport.clientWidth / width) + 1);
          while (track.children.length > copies) track.lastElementChild.remove();
          while (track.children.length < copies) {
            const copy = source.cloneNode(true);
            copy.setAttribute('aria-hidden', 'true');
            copy.inert = true;
            copy.querySelectorAll('[id], [data-shopify-editor-block]').forEach((node) => {
              node.removeAttribute('id');
              node.removeAttribute('data-shopify-editor-block');
            });
            track.append(copy);
          }
          this.style.setProperty('--hp-ticker-copies', copies);
        };
        this.io = new IntersectionObserver((entries) => {
          this.toggleAttribute('data-hp-motion-out-of-view', !entries.some((entry) => entry.isIntersecting));
        });
        this.io.observe(this);
        this.ro = new ResizeObserver(sync);
        this.ro.observe(viewport);
        this.ro.observe(source);
        const { signal } = this.ac;
        document.fonts.ready.then(() => { if (!signal.aborted) sync(); });
        sync();
      }
      disconnectedCallback() {
        this.io?.disconnect();
        this.ac?.abort();
        this.ro?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hp-video-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hp-video')) {
    customElements.define('hp-video', class extends HTMLElement {
      connectedCallback() {
        this.ac?.abort();
        this.io?.disconnect();
        this.ac = new AbortController();
        const video = this.querySelector('video');
        if (!video || !this.hasAttribute('data-autoplay')) return;
        const { signal } = this.ac;
        video.controls = false;
        video.setAttribute('role', 'button');
        video.tabIndex = 0;
        // Keep explicit intent on the element when Vue or the editor reconnects it.
        if (this.userIntent === undefined) this.userIntent = null;
        let inView = false;
        let wantsPlayback = false;
        const label = () => video.setAttribute('aria-label', video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        const sync = () => {
          const decorativePaused = window.hpMotion?.paused || this.matches('.hp-editor-block-selected') || this.closest('.hp-editor-block-selected');
          wantsPlayback = inView && !document.hidden && (this.userIntent === true || (this.userIntent !== false && !decorativePaused));
          if (wantsPlayback) video.play().catch(() => {});
          else video.pause();
        };
        const toggle = () => { this.userIntent = video.paused; sync(); };
        video.addEventListener('click', toggle, { signal });
        video.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          toggle();
        }, { signal });
        video.addEventListener('play', () => {
          if (!wantsPlayback && !video.paused) this.userIntent = true;
          label();
        }, { signal });
        video.addEventListener('pause', () => {
          // A pause outside our visibility/preference sync is deliberate and must survive Resume.
          if (wantsPlayback && video.paused && inView && !document.hidden) this.userIntent = false;
          label();
        }, { signal });
        document.addEventListener('hp:motion:change', sync, { signal });
        document.addEventListener('visibilitychange', sync, { signal });
        document.addEventListener('hp:editor:block-select', sync, { signal });
        document.addEventListener('hp:editor:block-deselect', sync, { signal });
        this.io = new IntersectionObserver((entries) => { inView = entries.some((entry) => entry.isIntersecting); sync(); }, { threshold: 0.1 });
        this.io.observe(this);
        sync();
        label();
      }
      disconnectedCallback() {
        this.ac?.abort();
        this.io?.disconnect();
        this.querySelector('video')?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
